import React from "react";

import { getFullName } from "helpers";

import closeIcon from "static/images/close-icon.png";
import styles from "./modal.module.scss";

const EquipmentViewModal = ({ setViewShow, viewShow, equipmentView }) => {
	const getAgentNames = equipmentView =>
		equipmentView?.agents?.map(agent => getFullName(agent)).join(", ");

	return (
		<div className={styles.wrappBoardingView}>
			{viewShow ? (
				<div className={styles.modal}>
					<div className={styles.modalContent}>
						<div className={styles.wrappCloseIcon}>
							<img
								src={closeIcon}
								alt="close"
								onClick={() => setViewShow(false)}
							/>
						</div>
						<div className={styles.wrappViewContent}>
							<p>MID:</p>
							<p className={styles.mid}>{equipmentView.mid}</p>
						</div>
						<div className={styles.wrappViewContent}>
							<div className={styles.wrappViewHeader}>
								<p className={styles.viewHeader}>Merchant:</p>
							</div>
							<div className={styles.wrappViewData}>
								<p className={styles.viewData}>
									{equipmentView.merchantName}
								</p>
							</div>
						</div>
						<div className={styles.wrappViewContent}>
							<div className={styles.wrappViewHeader}>
								<p className={styles.viewHeader}>
									Processor / Sponsor:
								</p>
							</div>
							<div className={styles.wrappViewData}>
								<p className={styles.viewData}>
									{equipmentView.processor} /{" "}
									{equipmentView.sponsor}
								</p>
							</div>
						</div>
						<div className={styles.wrappViewContent}>
							<div className={styles.wrappViewHeader}>
								<p className={styles.viewHeader}>
									Industry Type (MCC):
								</p>
							</div>
							<div className={styles.wrappViewData}>
								<p className={styles.viewData}>
									{equipmentView.industryType}
								</p>
							</div>
						</div>
						<div className={styles.wrappViewContent}>
							<div className={styles.wrappViewHeader}>
								<p className={styles.viewHeader}>Agent Name:</p>
							</div>
							<div className={styles.wrappViewData}>
								<p className={styles.viewData}>
									{getAgentNames(equipmentView) ||
										"House Account"}
								</p>
							</div>
						</div>
						<div className={styles.wrappViewContent}>
							<div className={styles.wrappViewHeader}>
								<p className={styles.viewHeader}>
									Agent Office:
								</p>
							</div>
							<div className={styles.wrappViewData}>
								<p className={styles.viewData}>
									{equipmentView.agentOffice}
								</p>
							</div>
						</div>
						<div className={styles.wrappViewContent}>
							<div className={styles.wrappViewHeader}>
								<p className={styles.viewHeader}>Carrier:</p>
							</div>
							<div className={styles.wrappViewData}>
								<p className={styles.viewData}>
									{equipmentView.carrier}
								</p>
							</div>
						</div>
						<div className={styles.wrappViewContent}>
							<div className={styles.wrappViewHeader}>
								<p className={styles.viewHeader}>
									Tracking Number:
								</p>
							</div>
							<div className={styles.wrappViewData}>
								<p className={styles.viewData}>
									{equipmentView.trackingNumber}
								</p>
							</div>
						</div>
						<div className={styles.wrappViewContent}>
							<div className={styles.wrappViewHeader}>
								<p className={styles.viewHeader}>Status:</p>
							</div>
							<div className={styles.wrappViewData}>
								<p className={styles.viewData}>
									{equipmentView.equipmentStatus}
								</p>
							</div>
						</div>
					</div>
				</div>
			) : null}
		</div>
	);
};

export default EquipmentViewModal;
